<template>
  <div>
    <!-- The results list (or a single auction, when the URL carries a lot
         number): the app's own view, on the band the WordPress page used to
         fill with an <iframe>. -->
    <section class="site_container results">
      <div class="site_embed site_embed--search">
        <SearchSlot />
      </div>
    </section>

    <section class="site_container enquiry_wrap">
      <SiteEnquiry />
    </section>
  </div>
</template>

<script>
import pageHead from '@/mixins/pageHead'
import { pageSchema } from '@/utils/schema'
import SearchSlot from '@/components/SearchSlot.vue'
import SiteEnquiry from '@/components/SiteEnquiry.vue'

export default {
  name: 'WynikiWyszukiwaniaPage',
  components: { SearchSlot, SiteEnquiry },
  mixins: [pageHead],

  pageHead: {
    title: 'Wyniki wyszukiwania - Japonia Cars',
    description: 'Pojazdy z japońskich aukcji spełniające wybrane kryteria.',
    schema: pageSchema({
      path: '/wyniki-wyszukiwania/',
      name: 'Wyniki wyszukiwania',
      breadcrumbs: [{ name: 'Wyniki wyszukiwania' }],
      published: '2026-07-01T09:14:04+00:00',
      modified: '2026-07-01T09:14:04+00:00',
    }),
  },
}
</script>

<style scoped>
/* Ta strona jest w całości ciemna, więc oba bloki idą przez pełną szerokość
   okna — bez limitu `.site_container` i bez białych marginesów `.site`.
   Szerokość treści ograniczają już same widoki (SearchView / AuctionView). */
.results,
.enquiry_wrap {
  max-width: none;
  padding-right: 0;
  padding-left: 0;
  background: #0d0d0d;
}

.results {
  padding-top: 0;
}

.enquiry_wrap {
  padding-bottom: 80px;
}

/* Panel zapytania styka się tu bezpośrednio z widokiem aukcji (#0d0d0d).
   Zrównujemy tło i ścinamy górne zaokrąglenie, żeby oba bloki czytały się
   jako jedna płaszczyzna. Na pozostałych stronach SiteEnquiry leży na jasnym
   tle i zachowuje swój domyślny wygląd. */
.enquiry_wrap :deep(.enquiry) {
  max-width: 1680px;
  margin: 0 auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background: #0d0d0d;
}
</style>
